module.exports = __webpack_public_path__ + "static/media/Avadhoot.e7d331d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team/images/Avadhoot.jpg
// module id = 1753
// module chunks = 147